import React from 'react';
import './PackagesPage.css';
const HeroBlock = ({ label, title, text, image, chipOne = 'Flexible Plans', chipTwo = 'Custom Quote' }) => (
  <section className="enhanced-hero" style={{ backgroundImage: `url(${image})` }}>
    <div className="container enhanced-hero-grid">
      <div className="enhanced-copy reveal-left">
        <span className="section-label eyebrow-dark">{label}</span>
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        <p>{text}</p>

        <div className="hero-actions">
          <a href="/contact-us" className="btn btn-primary">Get Free Consultation</a>
          <a href="/contact-us" className="btn btn-outline">Purchase Now</a>
        </div>

        <div className="hero-metrics">
          <span><strong>Complete</strong>Tracking</span>
          <span><strong>Fleet</strong>Management</span>
          <span><strong>Extra</strong>Features</span>
        </div>
      </div>

      <div className="hero-visual-wrap reveal">
        <div className="floating-orbit" />
        <div className="float-chip one"><b />{chipOne}</div>
        <div className="float-chip two"><b />{chipTwo}</div>
        <div className="hero-visual">
          <img src={image} alt={label} />
        </div>
      </div>
    </div>
  </section>
);

const commonFeatures = [
  'Real Time Tracking',
  'Real time GPRS Connectivity',
  'Nationwide coverage',
  'Location on call 24/7',
  'Web access',
  'Mobile Application',
  'History Playback',
  'History report',
  'Immobilization in case of emergency',
  'Theft & Snatched Recovery Assistance',
  'Battery Tamper Alerts on call',
  'Backup Support battery',
  'Ignition Alerts notifications ON/OFF',
  'Engine Kill by mobile App',
  'Activity Report'
];

const fleetFeatures = [
  'Real Time Tracking',
  'Real time GPRS Connectivity',
  'Nationwide coverage',
  'Location on call 24/7',
  'Web access',
  'Mobile Application',
  'Ignition Alerts notifications ON/OFF',
  'Over Speed Alerts notification',
  'Engine Kill by mobile App',
  'History Playback',
  'History report',
  'Activity Report',
  'Idle Report',
  'Trip Report',
  'Backup Support battery',
  'Trip Summary Report',
  'Over Speed Report',
  'Fleet Trip Report',
  'Fleet Mileage Report',
  'Immobilization in case of emergency',
  'Theft & Snatched Recovery Assistance',
  'Battery Tamper Alerts on call'
];

const rentalFeatures = [
  'Real Time Tracking',
  'Real time GPRS Connectivity',
  'Nationwide coverage',
  'Location on call 24/7',
  'Web access',
  'Mobile Application',
  'Immobilization in case of emergency',
  'Theft & Snatched Recovery Assistance',
  'Battery Tamper Alerts on call',
  'Backup Support battery'
];

const otherPackages = [
  'Asset Monitoring',
  '4G Dash Cam Monitoring',
  'Bike Monitoring',
  'Genset Monitoring',
  'Trip Base Tracking Services',
  'Fuel Monitoring',
  'Temperature Monitoring'
];

const extraFeatures = [
  '1 way communication',
  '2 way communication',
  'Seat Belt alert & Report',
  'Panic Button',
  'Door Sensor Open & Close',
  'Access Idle by SMS',
  'Hourly Base SMS'
];

const PackageCard = ({ title, subtitle, features, featured, button }) => (
  <div className={`package-card reveal ${featured ? 'featured' : ''}`}>
    <span className="section-label">{subtitle}</span>
    <h3>{title}</h3>
    <p>Professional DTS tracking plan designed for reliable vehicle monitoring and customer support.</p>
    <ul>
      {features.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
    <a href="/contact-us" className={featured ? 'btn btn-primary' : 'btn btn-outline'}>
      {button}
    </a>
  </div>
);

const PackagesPage = () => (
  <main className="enhanced-page packages-enhanced">
    <HeroBlock
      label="Packages"
      title="What You Need <em>Packages</em>"
      text="Choose from Basic, Standard, Fleet Management, Rental, and specialized DTS packages for personal vehicles, corporate fleets, assets, dashcams, bikes, gensets, fuel monitoring, and temperature monitoring."
      image="/dts-assets/ai/packages-hero.png"
      chipOne="Multiple Plans"
      chipTwo="Smart Add-ons"
    />

    <section className="enhanced-section alt">
      <div className="container">
        <div className="section-header reveal">
          <span className="section-label">Tracking Packages</span>
          <h2>Choose Your <em>Plan</em></h2>
          <div className="divider" />
          <p>
            Select a package according to your vehicle security, fleet management,
            rental operation, or specialized monitoring requirement.
          </p>
        </div>

        <div className="package-grid package-grid-large">
          <PackageCard
            title="Basic"
            subtitle="Personal Tracking"
            features={commonFeatures}
            button="Choose Your Plan"
          />

          <PackageCard
            title="Standard"
            subtitle="Smart Vehicle Security"
            features={commonFeatures}
            featured
            button="Choose Your Plan"
          />

          <PackageCard
            title="Fleet Management Package"
            subtitle="Corporate Fleets"
            features={fleetFeatures}
            button="Purchase Now"
          />
        </div>
      </div>
    </section>

    <section className="enhanced-section">
      <div className="container split-grid">
        <div className="feature-panel reveal-left">
          <span className="section-label">Rental Packages</span>
          <h2>Tracking Support for Rental Vehicles</h2>
          <p>
            DTS rental packages are designed for businesses that need reliable vehicle
            visibility, mobile access, emergency immobilization, recovery assistance,
            and battery tamper alerts.
          </p>

          <div className="mini-check-list">
            {rentalFeatures.map((item) => (
              <span key={item}>✓ {item}</span>
            ))}
          </div>

          <a href="/contact-us" className="btn btn-primary">Get Rental Package</a>
        </div>

        <div className="media-card reveal">
          <img
            src="https://images.unsplash.com/photo-1553440569-bcc63803a83d?auto=format&fit=crop&w=1200&q=80"
            alt="Rental vehicle tracking"
            loading="lazy"
          />
        </div>
      </div>
    </section>

    <section className="enhanced-section dark-band">
      <div className="container">
        <div className="section-header reveal">
          <span className="section-label eyebrow-dark">More Options</span>
          <h2>Other Packages & <em>Extra Features</em></h2>
          <div className="divider" />
          <p>
            Upgrade your tracking system with specialized monitoring packages and
            additional sensors according to your operational needs.
          </p>
        </div>

        <div className="addon-grid">
          <div className="addon-panel reveal">
            <h3>Other Packages</h3>
            <div className="addon-list">
              {otherPackages.map((item) => (
                <span key={item}>✅ {item}</span>
              ))}
            </div>
          </div>

          <div className="addon-panel reveal">
            <h3>Extra Features</h3>
            <div className="addon-list">
              {extraFeatures.map((item) => (
                <span key={item}>✅ {item}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default PackagesPage;